// extracted by mini-css-extract-plugin
export default {"file_upload_preview_box":"FileReader_file_upload_preview_box__4w4ed","file_upload_img":"FileReader_file_upload_img__-6Dz2","file_upload_file":"FileReader_file_upload_file__8LUje"};